import Vue from 'vue'
import Router from 'vue-router'
import LoginRegister from '@/components/LoginRegister'
import Home from '@/components/Home' // 假设首页组件是Home

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home' // 根路径默认跳首页
    },
    {
      path: '/login',
      name: 'LoginRegister',
      component: LoginRegister
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true } // 标记需要登录的路由
    }
  ]
})

// 路由前置守卫
router.beforeEach((to, from, next) => {
  // 从本地存储获取token
  const token = localStorage.getItem('token')
  
  // 核心逻辑：
  // 1. 如果访问的是登录页，且已有token → 自动跳首页
  if (to.path === '/login') {
    if (token) {
      next('/home') // 有token，跳首页
    } else {
      next() // 无token，放行到登录页
    }
  } 
  // 2. 如果访问的是需要登录的路由（如首页），无token → 跳登录页
  else if (to.meta.requiresAuth) {
    if (token) {
      next() // 有token，放行
    } else {
      next('/login') // 无token，跳登录页
    }
  } 
  // 3. 其他路由（如无需登录的公开页面），直接放行
  else {
    next()
  }
})

export default router